// Translation: Turkish > Notifications
const notifications = Object.freeze({})

// Export
export default notifications
